import { Injectable, OnDestroy } from '@angular/core';
import { Observable, BehaviorSubject, Subscription } from 'rxjs';
import { SessionData } from './session.service';

@Injectable({
  providedIn: 'root',
})
export class SessionTimerService implements OnDestroy {

  private isInitialized = false;
  private isPreviewInitialized = false;
  private remainingTimeSubject = new BehaviorSubject<number>(0);
  remainingTime$: Observable<number> = this.remainingTimeSubject.asObservable();

  private uuid = new BehaviorSubject<string>('');
  uuid$: Observable<string> = this.uuid.asObservable();

  private sessionDataSubject = new BehaviorSubject<SessionData>(new SessionData());
  sessionData$: Observable<SessionData> = this.sessionDataSubject.asObservable();

  private timerExpired = new BehaviorSubject<SessionData>(new SessionData());
  isTimerExpired$: Observable<SessionData> = this.timerExpired.asObservable();

  private timerSubscription: Subscription;

  private simpleSessionRemainingTimeSubject = new BehaviorSubject<number>(0);
  simpleSessionRemainingTime$: Observable<number> = this.simpleSessionRemainingTimeSubject.asObservable();

  notifyTimerExpired(data: SessionData) {
    this.timerExpired.next(data);
  }

  set requestUUID(uuid: string) {
    this.uuid.next(uuid);
  }

  get requestUUID(): string {
    return this.uuid.getValue();
  }

  get sessionData(): SessionData {
    return this.sessionDataSubject.getValue();
  }

  initializeTimer(sessionData: SessionData) {
    if (!this.isInitialized) {
      this.remainingTimeSubject.next(sessionData.time);
      this.sessionDataSubject.next(sessionData);

      const interval = setInterval(() => {
        const remainingTime = this.remainingTimeSubject.value;
        if (remainingTime > 15) {
          this.remainingTimeSubject.next(remainingTime - 1);
        } else {
          clearInterval(interval);
          this.sessionData.expired = true;
          this.sessionData.timerType = "server";
          this.notifyTimerExpired(this.sessionData);
        }
      }, 1000);

      this.isInitialized = true;
    }
    else{
      this.remainingTimeSubject.next(sessionData.time);
    }
  }

  initializeSimpleTimer(sessionTime: number) {
    if (!this.isPreviewInitialized) {
      this.remainingTimeSubject.next(sessionTime);

      const interval = setInterval(() => {
        const remainingTime = this.remainingTimeSubject.value;
        if (remainingTime > 15) {
          this.remainingTimeSubject.next(remainingTime - 1);
        } else {
          clearInterval(interval);
          this.sessionData.expired = true;
          this.sessionData.timerType = "client";
          this.notifyTimerExpired(this.sessionData);
        }
      }, 1000);

      this.isPreviewInitialized = true;
    }
    else{
      this.remainingTimeSubject.next(sessionTime);
    }
  }

  endSimpleSession() {
    localStorage.removeItem('session-remaining-time');
    this.sessionData.expired = true;
    this.sessionData.timerType = "client";
    this.isPreviewInitialized = false;
    this.notifyTimerExpired(this.sessionData);
  }

  endSessionOnClose() {
    localStorage.removeItem('session-remaining-time');
    this.sessionData.timerType = "client";
  }

  ngOnDestroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
